import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

declare const window: any;

const OtrosVehiculosComponent: React.FC = () => {
  return (
    <div className="otros-vehiculos-detail-component">
      <div className="title-otros-vehiculos-detail-component">
      Servicios adicionales{/* Oportunidades para este vehículo */}
      </div>
      <div className="opciones-otros-vehiculos-detail-component">
        <div
          className={`item-opciones-otros-vehiculos-detail-component`}
          style={{
            backgroundImage: "URL(../assets/01_Home/Thumbnail_Simulador.webp)",
          }}
        >
          <div
            className={`mascara-item-opciones-otros-vehiculos-detail-component`}
          >
            <div className="title-mascara-item-opciones-otros-vehiculos-detail-component">
              Nuestro catálogo
            </div>
            <Link to="/vehiculos" className="btn-page-other-page-home-component">
              Conocer
            </Link>
          </div>
        </div>
        <div
          className={`item-opciones-otros-vehiculos-detail-component`}
          style={{
            backgroundImage:
              "URL(../assets/01_Home/Thumbnail_Concesionarios.webp)",
          }}
        >
          <div
            className={`mascara-item-opciones-otros-vehiculos-detail-component`}
          >
            <div className="title-mascara-item-opciones-otros-vehiculos-detail-component">
              Cotiza tu Hyundai
            </div>
            <Link to="/posventa" className="btn-page-other-page-home-component">
              Conocer
            </Link>
          </div>
        </div>
        <div
          className={`item-opciones-otros-vehiculos-detail-component`}
          style={{
            backgroundImage: "URL(../assets/01_Home/Thumbnail_Repuestos.webp)",
          }}
        >
          <div
            className={`mascara-item-opciones-otros-vehiculos-detail-component`}
          >
            <div className="title-mascara-item-opciones-otros-vehiculos-detail-component">
              Simula tu cuota
            </div>
            <Link to="/simulador-de-cuotas" className="btn-page-other-page-home-component">
              Conocer
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtrosVehiculosComponent;
